/* <ldy-story>: gentle reveal the first time the story scrolls into view.
   Armed only when the section starts below the fold (so it is never hidden on load),
   brand animations are on (data-reveal) and the visitor has not asked for reduced motion. */
if (!customElements.get('ldy-story')) {
  customElements.define(
    'ldy-story',
    class LdyStory extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-reveal') || this.classList.contains('is-revealed')) return;
        if (!('IntersectionObserver' in window)) return;
        if (window.Shopify && window.Shopify.designMode) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        if (this.getBoundingClientRect().top <= window.innerHeight) return;

        this.classList.add('will-reveal');
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-revealed');
            this.disconnectObserver();
          },
          { threshold: 0.25 },
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.disconnectObserver();
      }

      disconnectObserver() {
        if (!this.observer) return;
        this.observer.disconnect();
        this.observer = null;
      }
    },
  );
}
